import { IssueStatuses } from '@/hooks/escript/types';
import { sortProductIssues } from '../../../pages/escript/order-medication/util';
import { UnavailableProductRefillCard } from '../../products/refill/UnavailableProductRefillCard';
import type { CantOrderProductsProps } from './types';
import { isMedication } from './utils';

export function CantOrderProducts({ products }: CantOrderProductsProps) {
  return (
    <>
      {products.sort(sortProductIssues).map((pip, index) => {
        if (!pip.issue || !isMedication(pip.product)) {
          return null;
        }

        const medication = pip.product;
        return (
          <UnavailableProductRefillCard
            key={medication.id + index}
            product={{
              id: medication.id,
              name: medication.name,
              price: medication.price,
              brand: medication.brand,
              is_out_of_stock: medication.productIssueStatus === IssueStatuses.OUT_OF_STOCK,
              is_generative_scripting: false,
              reasoning_toggle: pip.issue.info && pip.issue.info.length > 0,
              prescriptionCode: medication.prescriptionCode,
            }}
            issue={pip.issue}
            handleCheckProductStatus={null}
          />
        );
      })}
    </>
  );
}
